import gql from 'graphql-tag';

const GET_ORG_DETAIL = gql`
  query orgDetail($where: OrgWhereUniqueInput!) {
    org(where: $where) {
      id
      name
      domain
      config {
        providersVisible
        isAdmin
        isPartner
        isTrafficker
        exportData
        isSelfService
        hasInsights
        priceVisible
        isProcessor
        canResetPasswords
        campaignSummary
        isPacing
        pastData
        segment
        articles
        amplify
        configurator
        billing
        sitesAppsTransactions
        isBeta
      }
      dataConfig {
        reTargeting
        appIds
        roasFormat
        currency {
          currency
          conversionValue
        }
        tradeDeskIdentifier
        storageBucket
        googleCustomerId
        attributionWindow
        menuId
        dspAdvertiserId
        defaultDisplayAttributionWindow
        defaultPaidSearchAttributionWindow
        defaultSEOAttributionWindow
        seo
        semrushEnable
        semrushConfig {
          projectId
          rootDomainUrl
          rootKeyword
          competitor1stRootDomainUrl
          competitor2ndRootDomainUrl
        }
        googleAnalytics {
          viewId
          isGA4
        }
        bing {
          accountId
          customerId
        }
        tagProcessingConfig {
          processTag
        }
        paidSearchDataConfig {
          isEnabled
        }
      }
      paymentConfig {
        id
        providerId
        paymentProvider
      }
      brands(first: 2) {
        name
        logo {
          key
        }
      }
      description
      locations(first: 5) {
        street
        city
        state
      }
      logo {
        id
        key
        url
      }
      signInLogo {
        id
        key
        url
      }
      roles(first: 50, where: { isMaster: true }) {
        id
        name
        roleItems(first: 15) {
          id
          feature
          actions
        }
        users(first: 30) {
          id
        }
        isMaster
      }
      level
      chatWootId
      cpm
      rpm
      website
      platformDomain
      tagDomain
      CPAcronym
      parentOrder
      parentOrg {
        name
        id
        level
        advertiserKnowledgeBaseURL
      }
      isAllTimeFiltered
      zone
      paidSearchSummary {
        id
      }
      pricingModel {
        id
        model
        hasContract
        cpmList {
          id
          type
          advertiserCPM
          contractCPM
        }
        auctionPlus {
          id
          advertiserPercentage
          contractPercentage
        }
      }
    }
  }
`;

export default GET_ORG_DETAIL;
